import { useMatch } from 'react-router-dom';

import { useCurrentUser } from 'api/authentication/hooks';
import { Feature } from 'api/authentication/requests';

export const useFeature = (feature: Feature) => {
  const currentUser = useCurrentUser();
  return {
    isEnabled: currentUser?.company?.features?.includes(feature) ?? false,
  };
};

export const useJourneyDetailParams = () => {
  const params = useMatch('/workspaces/:workspaceId/journeys/:journeyId/*')?.params;
  return {
    journeyId: params?.journeyId ?? '',
    workspaceId: params?.workspaceId ?? '',
  };
};
